<template>
  <div
    v-if="loading"
    class="app-spinner"
  >
    <c-icon
      type="loading"
      spin
      size="28"
    />
  </div>
  <auth-view
    v-else-if="currentUser === null"
    title="Log in"
    mode="login"
  />
  <div
    v-else
    class="extension-login"
  >
    <div
      class="_container"
    >
      <div :style="{ marginBottom: '2rem' }">
        <a href="/">
          <img
            src="/logo.svg"
            :style="{ maxWidth: '13rem' }"
          >
        </a>
      </div>
      <div v-if="hasError">
        <div :style="{ color: $colors.red.base, marginBottom: '2rem' }">
          Something went wrong. Either your browser is not supported, or you are in Incognito mode.
          <b>
            Log in only works in regular window.
          </b>
        </div>
        <c-button
          stretch
          outlined
          @click="createToken"
        >
          Try again
        </c-button>
      </div>
      <div v-else-if="!tokenSent">
        <c-icon
          type="loading"
          spin
          size="28"
        />
      </div>
      <div v-else>
        You are now successfully logged in. You can close this tab.
      </div>
    </div>
  </div>
</template>

<script>
import AuthView from 'shared/components/AuthView.vue';
import CButton from 'shared/components/CButton.vue';
import CIcon from 'shared/components/CIcon.vue';
import useCurrentUser from '@/services/user';
import { USER_SERVICE } from 'shared/constants';
import { httpsCallable } from 'shared/services/firebase';
import { provide } from 'vue';

export default {
  name: 'ExtensionLogin',
  setup() {
    const userService = useCurrentUser();
    provide(USER_SERVICE, userService);
    return { currentUser: userService.currentUser, loading: userService.loading };
  },
  components: { CIcon, AuthView, CButton },
  data() {
    return { tokenSent: false, hasError: true };
  },
  methods: {
    async createToken() {
      this.hasError = false;
      try {
        const token = await httpsCallable(this.$functions, 'createCustomToken')(this.currentUser.uid);
        this.$browser.runtime.sendMessage(this.$route.query.extensionId, { token });
        this.tokenSent = true;
      } catch (e) {
        this.hasError = true;
        console.error(e);
      }
    },
  },
  watch: {
    currentUser() {
      if (this.currentUser === null) {
        return;
      }

      this.createToken();
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
.extension-login {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  ._container {
    max-width: 300px;
    padding: 0 4rem;
    text-align: center;
    font-size: $font-size-6;
  }
}

.app-spinner {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
